import styled from 'styled-components'

export const WrapperActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
`